export const BUTTON_TEXT_LABEL = 'Return This Part(s)'
export const BUTTON_TEXT_LABEL_WMO = 'Return Part(s)'
export const SUBMIT_ALL_TEXT = 'Submit All Returns'
export const buttonLabelText = ['Next', 'Submit', 'Submit All Returns']
export const eligibleStatuses = ['Pending', 'Processing', 'Shipped', 'Order Shipped', 'Delivered', 'In Transit']
